import Components from '../../Components';
import { MEETING_ROOM_RESERVATION_PATH } from './constants';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: MEETING_ROOM_RESERVATION_PATH,
  exact: true,
  name: 'navigation.menu.meetingRoomReservation',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isHardRedirect: true,
};

export default RouteConfig;
